export default __webpack_public_path__ + "static/media/GBS_Text_light.32769afa.png";